import { atom } from "jotai";

import { getStartSlotIdFromCourt } from "../../../../components/EditableRoundsStep/components/BookingDurationCourt/atoms/selectors/getStartSlotIdFromCourt";
import { UpdateLessonBookingInput } from "../../../../hooks/saveChangesHooks/useSaveChangesToLessonBooking/__generated__/useSaveChangesToLessonBookingMutation.graphql";
import { currentBookingAtom } from "../../../stores";
import { getBookingDurationAtom } from "../../getBookingDurationAtom/getBookingDurationAtom";
import { updatedCustomerRoundsAtom } from "../UpdatedRounds/UpdatedCustomerRounds/UpdatedCustomerRoundsAtom";
import { updatedGuestRoundsAtom } from "../UpdatedRounds/UpdatedGuestRoundsAtom/UpdatedGuestRoundsAtom";
import { updatedMemberRoundsAtom } from "../UpdatedRounds/UpdatedMemberRoundsAtom/UpdatedMemberRoundsAtom";
import { updatedNewGuestRoundsAtom } from "../UpdatedRounds/UpdatedNewGuestRoundsAtom/UpdatedNewGuestRoundsAtom";

export const updateLessonBookingPayloadAtom =
  atom<UpdateLessonBookingInput | null>((get) => {
    const currentBooking = get(currentBookingAtom);
    const duration = get(getBookingDurationAtom);
    if (!currentBooking) return null;
    const isPrivate = currentBooking.isPrivate;
    const updatedCustomerRounds = get(updatedCustomerRoundsAtom);
    const updatedMemberRounds = get(updatedMemberRoundsAtom);
    const updatedGuestRounds = get(updatedGuestRoundsAtom);
    const updatedNewGuestRounds = get(updatedNewGuestRoundsAtom);
    const startSlotId = currentBooking.startSlotId;
    // get the start slot id from the court (when and if we changed courts)
    const changedStartSlotId = get(getStartSlotIdFromCourt);
    // get the duration (when and if we changed duration)
    const ownerRound = currentBooking.rounds.find((r) => r.isOwner);
    const ownerClientId = ownerRound?.player?.id;

    const changedDuration = duration ?? undefined;
    const inputLessonBooking: UpdateLessonBookingInput = {
      bookingId: currentBooking.id,
      notifyMember: false,
      customerRounds: updatedCustomerRounds,
      memberRounds: isPrivate ? updatedMemberRounds : undefined,
      guestRounds: isPrivate ? updatedGuestRounds : undefined,
      newGuestRounds: isPrivate ? updatedNewGuestRounds : undefined,
      startSlotId: changedStartSlotId ?? startSlotId ?? "",
      durationMins: changedDuration ?? undefined,
      lessonTypeId: currentBooking.lessonTypeId ?? "",
      instructors: currentBooking.instructors ?? [],
      ownerClientId: ownerClientId ?? undefined,
      request: currentBooking.request
        ? {
            time: currentBooking.request.time || "",
            minTime: currentBooking.request.minTime || "",
            maxTime: currentBooking.request.maxTime || "",
          }
        : undefined,
    };

    return inputLessonBooking;
  });
